"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable-next-line */

var utils_1 = require("@lsg/utils");

var date_fns_1 = require("date-fns");

var react_1 = require("react");

var React = __importStar(require("react"));

var uniqid_1 = __importDefault(require("uniqid"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Icon_1 = require("../../atoms/Icon");

var IconLink_1 = require("../IconLink");

var InputHelper_1 = require("../InputHelper/InputHelper");

var Stateful_1 = require("./Stateful");

var Type;

(function (Type) {
  Type["text"] = "text";
  Type["password"] = "password";
  Type["date"] = "date";
})(Type = exports.Type || (exports.Type = {}));
/**
 * InputTextfield
 * @description
 * https://material.io/develop/web/components/input-controls/text-field/
 * https://confluence.neugelb.com/display/BR/Text-Input
 */


var InputTextfield =
/** @class */
function (_super) {
  __extends(InputTextfield, _super);

  function InputTextfield(props) {
    var _this = _super.call(this, props) || this;

    _this.onViewportChange = function () {
      if (_this.ref.current) {
        var computedStyle = window.getComputedStyle(_this.ref.current);
        _this.lineHeight = parseInt(computedStyle.lineHeight, 10);
        _this.verticalPadding = parseInt(computedStyle.paddingTop, 10) + parseInt(computedStyle.paddingBottom, 10);
      }
    };

    _this.adjustHeight = function () {
      if (_this.ref.current) {
        _this.ref.current.style.height = "auto";
        var numLines = Math.round((_this.ref.current.scrollHeight - _this.verticalPadding) / _this.lineHeight);
        _this.ref.current.style.height = _this.verticalPadding + numLines * _this.lineHeight + 1 + "px";
      }
    };

    _this.onBlur = function (e) {
      var value = _this.props.value;

      _this.setState({
        focus: false,
        inputValue: date_fns_1.isDate(value) ? date_fns_1.format(value, utils_1.DateUtils.getLocaleDateFormat("short")) : ""
      });

      if (_this.props.type === "date" && !date_fns_1.isDate(value)) {
        _this.props.onChange("", _this.props.name, e);
      }

      _this.props.onBlur(_this.props.name, e);
    };

    _this.onFocus = function (e) {
      _this.setState({
        focus: true
      });

      _this.props.onFocus(_this.props.name, e);
    };

    _this.onChange = function (e) {
      var value = e.target.value;

      if (_this.props.type === "date") {
        var selectionStart = e.target.selectionStart;
        var selectionEnd = e.target.selectionEnd;
        var hasNoSelection = selectionStart === value.length && selectionEnd === value.length;
        var doReplacement = hasNoSelection && value.length > _this.state.inputValue.length;

        _this.onChangeDate(value, e, doReplacement);
      } else {
        _this.props.onChange(value, _this.props.name, e);
      }
    };

    _this.onClear = function (e) {
      _this.ref.current.focus();

      _this.setState({
        inputValue: ""
      });

      _this.props.onChange("", _this.props.name, e);
    };

    _this.onKeyDown = function (e) {
      var key = e.key;

      _this.props.onKeyDown(key, _this.props.name, e);
    };

    _this.onClick = function (e) {
      _this.props.onClick(_this.props.name, e);
    };

    _this.onIconClick = function (e) {
      _this.props.onIconClick(_this.props.name, e);
    };

    _this.onIconFocus = function () {
      _this.setState({
        iconFocus: true
      });
    };

    _this.onIconBlur = function () {
      _this.setState({
        iconFocus: false
      });
    };

    _this.onDivClick = function () {
      _this.ref.current.focus();
    };

    _this.onMouseDown = function () {
      window.addEventListener("mouseup", _this.onMouseUp);

      _this.setState({
        isPasswordVisible: true
      });
    };

    _this.onMouseUp = function () {
      window.removeEventListener("mouseup", _this.onMouseUp);

      _this.setState({
        isPasswordVisible: false
      });

      _this.ref.current.focus();
    };

    _this.state = {
      focus: false,
      iconFocus: false,
      isPasswordVisible: false,
      inputValue: ""
    };
    _this.uuid = props.id || uniqid_1["default"]("lsg--input-textfield-");
    _this.ref = _this.props.inputRef || react_1.createRef();
    return _this;
  }

  InputTextfield.getDerivedStateFromProps = function (nextProps, prevState) {
    // keep state.inputValue and props.value in sync
    // To enable modifying a parsed date, only allow state.inputValue !== props.value, if props.value can be parsed as a date
    if (!date_fns_1.isDate(nextProps.value)) {
      return {
        inputValue: nextProps.value
      };
    }

    var currentDate = date_fns_1.parse(utils_1.DateUtils.autoDateSeparator(prevState.inputValue), utils_1.DateUtils.getLocaleDateFormat("short"), new Date());
    var nextDate = date_fns_1.isDate(nextProps.value) ? nextProps.value : date_fns_1.parse(utils_1.DateUtils.autoDateSeparator(nextProps.value), utils_1.DateUtils.getLocaleDateFormat("short"), new Date());

    if (!date_fns_1.isEqual(currentDate, nextDate)) {
      return {
        inputValue: date_fns_1.format(nextDate, utils_1.DateUtils.getLocaleDateFormat("short"))
      };
    }
  };

  InputTextfield.prototype.componentDidUpdate = function () {
    if (this.props.textArea) {
      this.adjustHeight();
    }
  };

  InputTextfield.prototype.componentDidMount = function () {
    utils_1.WindowEvents.addViewportCallback(this.onViewportChange);

    if (this.props.textArea) {
      this.onViewportChange();
      this.adjustHeight();
    }
  };

  InputTextfield.prototype.componentWillUnmount = function () {
    utils_1.WindowEvents.removeViewportCallback(this.onViewportChange);
    window.removeEventListener("mouseup", this.onMouseUp);
  };

  InputTextfield.prototype.onChangeDate = function (value, e, doReplacement) {
    var lastChar = value[value.length - 1];

    if (!/([0-9]|[.\-/])/.test(lastChar)) {
      // prevent any char that is not a number or a placeholder to be entered
      event.preventDefault();
    }

    var formattedStringValue = utils_1.DateUtils.autoDateSeparator(value, this.props.minDate && date_fns_1.startOfDay(this.props.minDate), this.props.maxDate && date_fns_1.endOfDay(this.props.maxDate));
    var stringValue = doReplacement ? formattedStringValue : value;
    var parsedDate = formattedStringValue.length >= InputTextfield.datePlaceholder.length && date_fns_1.parse(value, utils_1.DateUtils.getLocaleDateFormat("short"), new Date()); // parse returns a date-object here (if entered Date is valid)

    this.setState({
      inputValue: stringValue
    });
    this.props.onChange(date_fns_1.isValid(parsedDate) ? parsedDate : stringValue, this.props.name, e);
  };

  InputTextfield.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        clearIcon = _a.clearIcon,
        disabled = _a.disabled,
        iconName = _a.iconName,
        iconText = _a.iconText,
        invalid = _a.invalid,
        helperText = _a.helperText,
        errorText = _a.errorText,
        label = _a.label,
        placeholderProp = _a.placeholder,
        readOnly = _a.readOnly,
        hasWidget = _a.hasWidget,
        manualFocus = _a.manualFocus,
        htmlAttrs = _a.htmlAttrs,
        valueProp = _a.value,
        optional = _a.optional,
        iconFocusable = _a.iconFocusable,
        textArea = _a.textArea,
        type = _a.type,
        name = _a.name;
    var _b = this.state,
        focus = _b.focus,
        iconFocus = _b.iconFocus,
        isPasswordVisible = _b.isPasswordVisible,
        inputValue = _b.inputValue;
    var value = type === "date" ? inputValue : valueProp;
    var placeholder = placeholderProp || (type === "date" ? InputTextfield.datePlaceholder : "");
    var hasInlineLabel = !value && !(focus && !hasWidget) && !iconFocus && !readOnly;
    var Component = textArea ? "textarea" : "input";

    if (iconName && !iconText) {
      // tslint:disable no-console
      console.warn("Accessibility: InputTextfield has an icon, but no iconText", this); // tslint:enable
    }

    return React.createElement("div", {
      id: this.uuid,
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "input-textfield", hasInlineLabel && CSSPrefix_1.lsgPre + "input-textfield__label-inline", readOnly && CSSPrefix_1.lsgPre + "input-textfield__read-only", hasWidget && CSSPrefix_1.lsgPre + "input-textfield__has-widget", manualFocus && CSSPrefix_1.lsgPre + "input-textfield__manual-focus", (invalid || errorText) && CSSPrefix_1.lsgPre + "input-textfield__invalid", className]),
      onClick: this.onDivClick
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "input-textfield-container"
    }, React.createElement(Component, __assign({}, htmlAttrs, {
      "aria-invalid": invalid ? true : undefined,
      disabled: disabled,
      placeholder: !hasInlineLabel ? placeholder : undefined,
      readOnly: readOnly || hasWidget,
      id: this.uuid + "_textfield",
      className: CSSPrefix_1.lsgPre + "input-textfield-input",
      type: !type || type === "password" && isPasswordVisible || type === "date" ? "text" : type,
      value: value,
      onBlur: this.onBlur,
      name: name,
      onFocus: this.onFocus,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      onClick: this.onClick,
      ref: this.ref,
      tabIndex: htmlAttrs ? htmlAttrs.tabIndex : disabled || readOnly ? -1 : undefined,
      rows: textArea ? 1 : undefined
    })), React.createElement("label", {
      className: CSSPrefix_1.lsgPre + "input-textfield-label",
      htmlFor: this.uuid + "_textfield",
      id: this.uuid + "_label"
      /* we need this to set aria-labelled by correctly */

    }, label, optional === true && " (" + utils_1.Localization.texts.lsg.component._general.optional + ")" || optional && " (" + optional + ")"), React.createElement(IconLink_1.IconLinkGroup, {
      direction: IconLink_1.IconLinkGroup.Directions.HORIZONTAL
    }, clearIcon && value && !readOnly && !disabled && React.createElement(IconLink_1.IconLink, {
      className: CSSPrefix_1.lsgPre + "input-textfield-clear",
      iconName: Icon_1.Icon.Names.interaction___close,
      look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER,
      onClick: this.onClear,
      htmlAttrs: {
        tabIndex: -1,
        role: "none"
      }
    }, utils_1.Localization.texts.lsg.component.InputTextfield.clear), iconName && type !== "password" && React.createElement(IconLink_1.IconLink, {
      className: CSSPrefix_1.lsgPre + "input-textfield-icon",
      iconName: iconName,
      look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER,
      onClick: this.onIconClick,
      onFocus: this.onIconFocus,
      onBlur: this.onIconBlur,
      htmlAttrs: {
        tabIndex: iconFocusable ? 0 : -1
      }
    }, iconText), type === "password" && React.createElement(IconLink_1.IconLink, {
      className: CSSPrefix_1.lsgPre + "input-textfield-icon",
      iconName: isPasswordVisible ? Icon_1.Icon.Names.interaction___eyeView : Icon_1.Icon.Names.interaction___eyeView,
      look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER,
      onMouseDown: this.onMouseDown,
      onFocus: this.onIconFocus,
      onBlur: this.onIconBlur,
      htmlAttrs: {
        tabIndex: iconFocusable ? 0 : -1
      }
    }, utils_1.Localization.texts.lsg.component.InputTextfield.reveal))), (helperText || errorText) && React.createElement(InputHelper_1.InputHelper, {
      helperText: helperText,
      errorText: errorText
    }));
  };

  InputTextfield.Stateful = Stateful_1.Stateful;
  InputTextfield.Type = Type;
  InputTextfield.defaultProps = {
    clearIcon: true,
    label: "",
    placeholder: "",
    name: "",
    onBlur: function onBlur() {
      /* empty */
    },
    onFocus: function onFocus() {
      /* empty */
    },
    onChange: function onChange() {
      /* empty */
    },
    onKeyDown: function onKeyDown() {
      /* empty */
    },
    onClick: function onClick() {
      /* empty */
    },
    onIconClick: function onIconClick() {
      /* empty */
    }
  };
  InputTextfield.datePlaceholder = utils_1.Localization.texts && utils_1.Localization.texts.lsg.component.InputDatepicker.placeholder;
  return InputTextfield;
}(React.Component);

exports.InputTextfield = InputTextfield;